export class DDCustomer implements I_DDCustomer {
    id: string;
    accountCode: string;
    firstName: string;
    lastName: string;
    companyName: string;
    email: string;
    phoneNumber: string;
    addressLine1: string;
    addressLine2: string;
    addressLine3: string;
    suburb: string;
    state: string;
    postcode: string;
    phone: string;

    constructor(data: Partial<I_DDCustomer>) {
        Object.assign(this, data);
    }

    get fullName() {
        return `${this.firstName} ${this.lastName}`;
    }
}

export interface I_DDCustomer {
    id?: string;
    accountCode?: string;
    companyName?: string;
    firstName?: string;
    lastName?: string;
    email?: string;
    addressLine1?: string;
    addressLine2?: string;
    addressLine3?: string;
    suburb?: string;
    state?: string;
    postcode?: string;
    phone?: string;
}

export interface IGenericCustomer {
    company_name?: string,
    first_name?: string,
    last_name?: string,
    message?: string,
    prefix?: string,
    address_1?: string,
    address_2?: string,
    address_3?: string,
    city?: string,
    post_code?: string,
    region?: string,
    country?: string,
    phone?: string,
    culture?: string,
    process_datetime?: string,
    next_billing_date?: string,
    last_billing_date?: string,
    user_name?: string,
    password?: string,
    error_message?: string,
    email?: string,
    customer_id?: string,
    allow_random?: string,
    accountcode?: string,
    amount?: string,
    tenant_desc?: string,
    min_threshold?: string,
    max_threshold?: string,
    threshold_email?: string,
    threshold_phone?: string,
    tenant_type?: string,
    related_csn?: string,
    contains_usage?: string,
    digital_wallet_id?: string
}

export interface UpdateCustomerSubscriptionsModel {
    customerId?: string,
    vendorCustomerId?: string,
    programType?: string
}